module.exports = __webpack_public_path__ + "img/suporte.1948fc71.png";